import React from 'react';
import {FaAngleLeft} from "react-icons/fa";

const ShowDisplay = ({display, setDisplay}) => {
    const handleDisplay = () => {
        setDisplay(!display);
    };

return (<FaAngleLeft className='left-arrow show-display' onClick={handleDisplay}/>);
};

export default React.memo(ShowDisplay);